/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Points in Flensburg.   (german: Punkte in Flensburg, Eintrag Verkehrszentralregister)   (bipro-versicherung-kraftfahrt::PartnerdatenKfz)     * `None`      - currently no points   * `OneOrMore` - has one or more points   * `Unknown`   - number of points is unknown
 */
export const PointsInFlensburg = {
  None: 'None',
  OneOrMore: 'OneOrMore',
  Unknown: 'Unknown',
} as const;
export type PointsInFlensburg = (typeof PointsInFlensburg)[keyof typeof PointsInFlensburg];
